import React, { useEffect, useState, Fragment } from 'react';
import { isEmpty } from "lodash"

import Spin from '../../../commonModules/interface/Spin';
import { CardLayout, BreadCrumb } from './containers/Layout';
import ListSaleItem from './sales/ListSaleItem.jsx';
import ListSale from './transfers/sales/ListTransferSale.jsx';
import Form from './sales/Form.jsx';
// import SingleSale from './sales/SingleSale.jsx';
import SingleShop from './shops/SingleShop';
import { Button, Card, Grid, Box, IconButton } from '@material-ui/core';
import { ListRounded, ListAltRounded } from '@material-ui/icons';
import CardPage from '../../../commonModules/layouts/CardPage';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import DatePickerCustom from '../../../commonModules/interface/DatePickerCustom';
import { firstDayOfYear, sixMonthsAgo } from '../../../commonModules/utils/statsFunctions';
import DateFilter, { filterDate } from './Filter/DateFilter';
import ShopFilter, { filterShop } from './Filter/ShopFilter';
import AccordionFilter from './Filter/AccordionFilter';
import SingleTransferSale from './transfers/sales/SingleTransferSale';

const Sales = (props) => {
    const [end_date,setEnd_date] = useState(new Date());
    const [clients,setClients] = useState([]);
    const [state, setState] = useState({
        view: props.new ? "new" : "list",
        listview: "sale",

        singleShop:{},
        singleSale:{
            sale:{},
            shop:{},
            client:{},
            agent:{},
        },

        breadcrumb: "",
        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,

        selectShop: {label:"", value:""},
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchCredit: "", 
        searchProduct: "", 
		start_date: firstDayOfYear,
    })
        
    useEffect(() => {
        if(isEmpty(props.AGENTS)){
            props.fetchAgents()
        }
        let clients = createClientList()
        setClients(clients)
        const endOfDay = new Date();
        endOfDay.setHours(23, 59, 59);
        setEnd_date(endOfDay);
    }, []);
    useEffect(() => {
        let clients = createClientList()
        setClients(clients)
    }, [props.CLIENTS]);


    
    // select options 
        const createClientList = () => {
            const list = [{value:"", label:"Tous les Clients"}]
            const { CLIENTS } = props
            if( CLIENTS ){
                Object.values(CLIENTS).map(client => { 
                    list.push (       
                        {value:client.id, label:client.client_lastname} 
                    )
                })
            } 
            return list
        }
        const normalizeStr = (str) => {// remove accent and lower case str
            if (str){
                console.log("str exist", {str}, isEmpty(str));
                str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
            return str
        }
        const prodFilter = (prodID) => {
            const { PRODUCTS } = props;
            const { searchProduct } = state
    
            let product = PRODUCTS[prodID]
            let searching = searchProduct ? normalizeStr(searchProduct) : ""
    
            const productName = product ? normalizeStr(product.name) : ""
            const productRef = product ? normalizeStr(product.ref) : ""
            const productType = product ? normalizeStr(product.type) : ""
            const productBrand = product ? normalizeStr(product.marque) : ""
    
            return ( 
                productName.indexOf(searching) !== -1 ||
                productRef.indexOf(searching) !== -1 ||
                productType.indexOf(searching) !== -1 ||
                productBrand.indexOf(searching) !== -1
            )  
        }

        const handleChange = (e) => {
            const { name, value } = e.target;
            setState(prevState => ({...prevState,
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            }))
        }
        const handleSelect = (option, name) => {
            setState(prevState => ({...prevState,
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            }))
        } 

        const handleSelectMulti = (option, name) => {
            if(option){
                setState(prevState => ({...prevState,
                    [name]: option,
                    currentPage: 0,
                    currentPageProd: 0,
                }))
            } else {
                setState(prevState => ({...prevState,
                    [name]: {label: "", value: ""},
                    currentPage: 0,
                    currentPageProd: 0,
                }))
    
            }
        }
        const getFilteredList = (saleList) => {

            //const { SALES } = props;
            const { selectShop, searchClient, searchFacture, searchType, searchCredit } = state;
            
            let list = filterDate(saleList, state.start_date, end_date, "creation_date")
            // status
            if (typeof searchCredit == "boolean"){
                list = list.filter(item => item.sale_credit == searchCredit)
            }
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
                // list = list.filter(item => filterClients(item))
            }
            // type
            if(!isEmpty(searchType)){
                if (searchType === "commercial") {
                    list = list.filter(item => item.shop_id === "Commercial")
                } else {
                    list = list.filter(item => item.nature === searchType)
                }
            }

            list = filterShop(list, selectShop)

            // fact
            if(!isEmpty(searchFacture)){
                list = list.filter(item => {
                    const searchLower = searchFacture.toLocaleLowerCase();
                    const hasIdMatch = item.id && item.id.indexOf(searchLower) > -1;
                    const hasInternRefMatch = item.intern_ref_id && item.intern_ref_id.indexOf(searchLower) > -1;
                    return hasIdMatch || hasInternRefMatch;
                })
            }
            return list
        }
        
    // CLEAR & DISPLAY
    const handleClose = () => {
        setState(prevState => ({...prevState,
                view:"list",
                breadcrumb: "",
            }));
        }
        const handleSingleSale = (sale, shop, client, agent) => {
            setState(prevState => ({...prevState,
                view:"sale",
                breadcrumb:`${sale.nature} n°${sale.id}`,
                singleSale:{sale, shop, client, agent},
            }))
        }
        const handleSingleShop = (shop) => {
            setState(prevState => ({...prevState,
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            }))
        }
        const onChangePage = (pageOfItems, page, rowsPerPage) => {
            setState(prevState => ({...prevState,
                currentPage:page, rowsPerPage }));
        }
        const onChangePageProd = (pageOfItemsProd, page , rowsPerPage) => {
            setState(prevState => ({...prevState,
                currentPageProd:page , rowsPerPage}));
        }


        return(
            <CardPage title="Ventes" storehouse action={
                <Box>
                    {state.view === "list" &&
                    <Fragment>
                        <Button color="primary" variant="contained"
                            onClick={ ()=> setState(prevState => ({...prevState,view: "new", breadcrumb:"Nouveau"})) }
                        > Nouvelle Vente </Button>
                        {state.listview === "sale" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Produits"
                                onClick={()=> setState(prevState => ({...prevState, view: "list", listview: "prodList" })) }
                            >
                                <ListRounded />
                            </IconButton>
                        }
                        {state.listview === "prodList" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Ventes"
                                onClick={()=> setState(prevState => ({...prevState, view: "list", listview: "sale" })) }
                            >
                                <ListAltRounded />
                            </IconButton>
                        }
                    </Fragment>
                    }
                </Box>
            }>
                <BreadCrumb breadcrumb={ state.breadcrumb } title="Ventes" back={handleClose} />
                {state.view === "new" &&
                    <Form {...props} handleClose={ handleClose } />
                }
                {state.view === "sale" &&
                    <SingleTransferSale 
                        sale={state.singleSale.sale} 
                        transfer={state.singleSale.sale} 
                        shop={state.singleSale.shop} 
                        client={state.singleSale.client} 
                        agent={state.singleSale.agent} 
                        {...props} 
                        getPhoto={props.getPhoto} />
                }
                {state.view === "shop" &&
                    <SingleShop shop={state.singleShop} {...props} />
                }
                  
                {state.view === "list" &&
                // {state.view === "list" && (state.listview === "sale" ||  state.listview === "prodList") &&
                <AccordionFilter>
                    <Grid container>
                        <DateFilter
                            handleChangeDate={(date, name) => {if(name==="end_date"){console.log("End date",date);setEnd_date(date)}else{setState(prevState => ({...prevState, [name]: date }))}}}
                            {...state}
                            end_date={end_date}
                        />
                        <Grid item xs={12} md={6}>
                            {/* <InputSelect
                                options={shops}
                                value={state.selectShop}
                                label="Sélectionner un Magasin"
                                onChange={(option) => handleSelect(option, "selectShop") }
                            />  */}
                            <ShopFilter
                                fieldName="selectShop"
                                value={state.selectShop}
                                handleSelect={handleSelectMulti}
                            />
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={[
                                    {value: "", label: "Tous"},
                                    {value: "payg", label: "PayG"},
                                    {value: "vente", label: "Vente"},
                                    // {value: "installation", label: "Installation"},
                                    {value: "commercial", label: "Commercial"},
                                ]}
                                value={state.searchType}
                                label="Type"
                                onChange={(option) => handleSelect(option, "searchType") }
                            /> 
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={clients}
                                value={state.searchClient}
                                label="Client"
                                onChange={(option) => handleSelect(option, "searchClient") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputText
                                label="Facture"
                                value={state.searchFacture}
                                name="searchFacture"
                                onChange={handleChange}
                            /> 
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={[
                                    {value: "", label: "Tous"},
                                    {value: true, label: "À crédit"},
                                    {value: false, label: "Comptant"},
                                ]}
                                value={state.searchCredit}
                                label="Paiement"
                                name="searchCredit"
                                onChange={(option) => handleSelect(option, "searchCredit")}
                            /> 
                        </Grid>
                        {state.listview === "prodList" &&
                        <Grid item xs={12} md={6}>
                            <InputText 
                                name="searchProduct" 
                                value={state.searchProduct} 
                                placeholder="Rechercher par produit " 
                                label="Rechercher"
                                onChange={ handleChange} 
                            />
                        </Grid>
                        }
                    </Grid>
                </AccordionFilter>
                }
                {props.STATE.sales.fetching && <Spin noOverlay />}
               
                {state.view === "list" && state.listview === "sale" &&
                <Box>                    
                    {/* {!isEmpty(props.SALES) && */}
                        <ListSale 
                            {...props}
                            {...state}
                            end_date={end_date}
                            dataview={"vente"}
                            onChangePage={onChangePage}
                            handleSingleShop={handleSingleShop}  
                            handleSingleSale={handleSingleSale}  
                            getFilteredList={getFilteredList}  
                        />
                    {/* } */}
                </Box>
                }
                {state.view === "list" && state.listview === "prodList" &&
                <Box> 
                    {!isEmpty(props.SALES) &&
                        <ListSaleItem
                            {...props}
                            {...state}
                            onChangePage={onChangePageProd}
                            handleSingleShop={handleSingleShop}  
                            handleSingleSale={handleSingleSale}  
                            getFilteredList={getFilteredList}  
                            prodFilter={prodFilter}  
                        />
                    }
                </Box>
                }
            </CardPage>
        )
}

export default Sales